import type { components, paths } from "@whilecat/generated/openapi/course.ts";
import { LevelInfo } from "@whilecat/services/dto/level-info.ts";
import { getClient } from "./client-utils.ts";

type CourseT = components["schemas"]["Course"];

export interface Course extends CourseT {
    completedLessons: number;
    totalLessons: number;
    enrolled: boolean;
}

const client = getClient<paths>();

export async function getCoursesMesh() {
    const { data } = await client.withRetries(2).GET("/public/mesh/course");
    return data!.map(x => ({
        ...x.course,
        completedLessons: x.completedLessons,
        totalLessons: x.totalLessons,
        enrolled: x.enrolled,
    }));
}

export async function getCourseLevels(courseUuid: string) {
    try {
        const { data } = await client.withRetries(2).GET("/public/course/{courseUuid}/level", {
            params: { path: { courseUuid } },
        });

        const levels = data!.map(level => new LevelInfo(level.id, level.name, level.url, level.sourcePath, false));
        return { ok: true, levels, enrolled: false };
    } catch (e) {
        console.error(e);
        return { ok: false, levels: [], enrolled: false };
    }
}
